'use client';

import { useRouter } from 'next/navigation';
import { ChangeEvent, FormEvent, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { twJoin } from 'tailwind-merge';

import { Button } from '@/components/Button';
import * as Input from '@/components/Input';
import { useLayout } from '@/context/layout-context';
import { Paths } from '@/utils/paths';

import { useMobileNavigation } from './mobile-navigation-context';

export function Search() {
  const [near, setNear] = useState('');

  const { content } = useLayout();
  const { onCloseNavigation } = useMobileNavigation();
  const { searchZipCodePlaceholder } = content.mobileNav;
  const router = useRouter();

  const onNearChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNear(e.target.value);
  };

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const isEmpty = near.trim() === '';

    if (isEmpty) return;

    const url = new URL(window.location.href);
    url.pathname = Paths.SEARCH;
    url.searchParams.set('near', near);

    router.push(url.href);

    onCloseNavigation();
  };

  return (
    <form className="w-11/12 max-w-md flex-1" onSubmit={onSubmit}>
      <Input.Root className="h-9 gap-0">
        <Input.Control
          className={twJoin(
            'h-9 flex-1 rounded-md bg-white pr-6 pl-3 text-base',
            'shadow-[0_3px_6px_rgba(0,0,0,.1)]',
            'focus-visible:ring-zmyle-secondary outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
            'placeholder:text-gray-550 placeholder:font-normal',
          )}
          placeholder={searchZipCodePlaceholder}
          onChange={onNearChange}
          value={near}
        />

        <Input.Suffix className="-ml-5">
          <Button type="submit" className="rounded-l-none">
            <FaSearch className="size-5" />
          </Button>
        </Input.Suffix>
      </Input.Root>
    </form>
  );
}
